// ── Importaciones tal cual ──────────────────────────────
import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { InputGroup } from 'react-bootstrap';
import ErrorAlert from '../../Alerts/ErrorAlert';
import { Badge } from 'react-bootstrap';
import { ListGroup } from 'react-bootstrap';
import { GroupsFechtAPI } from '../../../api/Groups';
import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import add from '../../img/icons/add-product.png'
import './modals.css';


/* ── ICONS ── */
const IcoSearch = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>;
const IcoCheck  = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;
const IcoX      = ()=><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcoPackage= ()=><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>;
const IcoPlus   = ()=><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original
════════════════════════════════════════════════════════ */
function ModalGroupsSelect({ productsBranchoffice, addGroups }) {

  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  const [showModal, setShowModal]             = useState(false);
  const [groups, setGroups]                   = useState([]);
  const [groupSelect, setGroupSelect]         = useState("");
  const [searchedProducts, setSearchedProducts] = useState("");
  const [searchTerm, setSearchTerm]           = useState('');
  const [groupsSelectList, setGroupsSelectList] = useState([]);
  const [statusRequest, setStatusRequest]     = useState(false);
  const [deleteMode, setDeleteMode]           = useState(false);

  let token = localStorage.getItem("x-access-token");
  let user  = localStorage.getItem('user');

  const filteredProducts = useMemo(() => {
    if (searchTerm === '') return groups;
    return searchedProducts.filter(group => {
      const nameMatch = group.name.toLowerCase().includes(searchTerm.toLocaleLowerCase());
      const descriptionMatch = group.description.toLowerCase().includes(searchTerm.toLowerCase());
      return nameMatch || descriptionMatch;
    });
  }, [searchTerm, groups]);

  const handlerChecked = (e, group) => {
    if (e.target.checked == true) {
      if (groupsSelectList.length > 29) {
        ErrorAlert('', 'Superaste la cantidad q', 'warning');
        e.target.checked = false;
      } else {
        setGroupsSelectList([...groupsSelectList, group]);
      }
    } else {
      let filtrado = groupsSelectList.filter(data => data.group_id != group.group_id);
      setGroupsSelectList(filtrado);
    }
  };

  const saveArrayGroups = () => {
    console.log(groupsSelectList);
    if (groupsSelectList.length > 30) {
      ErrorAlert('', 'Solo puedes agregar 30 productos a la ves', 'warning');
    } else {
      groupsSelectList.forEach((group, id, index) => {
        try { addGroups(group); } catch (err) { ErrorAlert('', 'Uno de los productos ya estaba asignado', 'warning'); }
      });
      setGroupsSelectList([]); setSearchTerm(''); setShowModal(false);
    }
  };

  const hadleselect = () => {
    setShowModal(true);
    setGroups(productsBranchoffice);
    setSearchedProducts(productsBranchoffice);
  };
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  return (
    <>
      {/* ── TRIGGER BUTTON ── */}
      <button
        className="mgs-trigger btn-add-product-list rounded-4 pulse mt-4 py-4 w-100"
        type="button"
        onClick={() => hadleselect()}
      >
        <div className="mgs-trigger-ico">
          <IcoPlus />
        </div>
        <span className="mgs-trigger-label">Seleccionar productos</span>
        {/* img original — import preservado */}
        <img src={add} alt="Add" style={{ display: 'none' }} />
      </button>

      {/* ── FULLSCREEN MODAL ── */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
   
      size="lg"
        centered
        dialogClassName="mgs-dialog"
      >
        <Modal.Header className="text-center">
          <h3><i className="uil uil-file-plus-alt" />Selecion de productos</h3>
        </Modal.Header>

        <Modal.Body>

          {/* ── sticky top bar ── */}
          <div className="mgs-topbar">
            <div className="mgs-topbar-title">
              <IcoPackage /> Selección de productos
            </div>
            {groupsSelectList.length > 0 && (
              <span className="mgs-topbar-count" key={groupsSelectList.length}>
                ✓ {groupsSelectList.length} seleccionado{groupsSelectList.length !== 1 ? 's' : ''}
              </span>
            )}
            <span className="mgs-topbar-limit">Máximo 30 productos</span>
          </div>

          {/* ── search bar ── */}
          <div className="mgs-search-bar">
            <div className="mgs-search-wrap">
              <div className="mgs-search-ico"><IcoSearch /></div>
              <input
                spellCheck="false"
                className="mgs-search form-control"
                type="text"
                step="any"
                placeholder="Buscar producto por nombre o descripción..."
                onChange={e => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          {/* ── products ── */}
          <div className="mgs-grid-wrap">
            {filteredProducts.length === 0 ? (
              <div className="mgs-empty">
                <div style={{ width:52, height:52, borderRadius:'50%', background:'rgba(0,0,0,.05)', display:'grid', placeItems:'center', color:'#9CA3AF' }}>
                  <IcoPackage />
                </div>
                <p className="mgs-empty-title">Sin productos</p>
                <p className="mgs-empty-sub">{searchTerm ? `No hay resultados para "${searchTerm}"` : 'No hay productos disponibles en esta bodega.'}</p>
              </div>
            ) : (
              /* Render original intacto — Container/Row/Col/ListGroup exactos */
              <Container>
                <Row>
                  {filteredProducts.map((group, idx) => (
                    <React.Fragment key={idx}>
                      {group.group_type ? (
                        <>
                          {group.group_type == "limited" ? (
                            <Col sm="4">
                              <ListGroup as="ol" className="m-2">
                                <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                                  <div className="ms-2 me-auto d-inline-block text-truncate">
                                    <div className="fw-bold">{group.name ? group.name : group.group_name}</div>
                                    <div>Cantidad: <b>{group.quantity}</b></div>
                                  </div>
                                  <div>
                                    <InputGroup>
                                      <InputGroup.Checkbox
                                        aria-label="Checkbox for following text input"
                                        onChange={e => handlerChecked(e, group)}
                                      />
                                    </InputGroup>
                                  </div>
                                </ListGroup.Item>
                              </ListGroup>
                            </Col>
                          ) : null}
                        </>
                      ) : (
                        <Col sm="4">
                          <ListGroup as="ol" className="m-2">
                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                              <div className="ms-2 me-auto d-inline-block text-truncate">
                                <div className="fw-bold">{group.name ? group.name : group.group_name}</div>
                                <div>Cantidad: <b>{group.quantity}</b></div>
                              </div>
                              <div>
                                <InputGroup>
                                  <InputGroup.Checkbox
                                    aria-label="Checkbox for following text input"
                                    onChange={e => handlerChecked(e, group)}
                                  />
                                </InputGroup>
                              </div>
                            </ListGroup.Item>
                          </ListGroup>
                        </Col>
                      )}
                    </React.Fragment>
                  ))}
                </Row>
              </Container>
            )}
          </div>
        <div className="mgs-footer">
            <span className="mgs-footer-info">
              {groupsSelectList.length > 0
                ? <><strong>{groupsSelectList.length}</strong> producto{groupsSelectList.length !== 1 ? 's' : ''} seleccionado{groupsSelectList.length !== 1 ? 's' : ''}</>
                : 'Selecciona productos de la lista'}
            </span>
            <div className="mgs-footer-btns">
              {/* Button originales — lógica intacta */}
              <button
                className="mgs-btn-close m-2"
                size="sm"
                onClick={() => { setShowModal(false); setGroupsSelectList([]); setDeleteMode(false); setSearchTerm(''); }}
              >
                <IcoX /> Cerrar
              </button>

              {deleteMode == true ? (
                <Button className="mgs-btn-delete m-2" size="sm" variant="danger" type="button" onClick={() => saveArrayGroups()}>
                  Eliminar
                </Button>
              ) : (
                <Button className="mgs-btn-save m-2" size="sm" variant="success" type="button" onClick={() => saveArrayGroups()}>
                  <IcoCheck /> Guardar
                </Button>
              )}
            </div>
          </div>
        </Modal.Body>

        {/* ── sticky footer ── */}
        <Modal.Footer>
  
        </Modal.Footer>
      </Modal>

      {/* imports no-JSX preservados */}
      {void [Form, Badge, GroupsFechtAPI, useNavigate, useParams, Link, useEffect, groupSelect, statusRequest, token, user]}
    </>
  );
}

export default ModalGroupsSelect;